/**
 * Audit Log API Service
 *
 * API methods for querying audit log entries.
 * Uses standardized API response format with cursor-based pagination.
 */

import apiClient from "./client";
import type { ApiCollectionResponse, ApiPagination } from "../types/api.types";
import type { AuditLogEntry, AuditLogListQuery } from "../types/audit-log.types";

export interface ListAuditLogsResponse {
  items: AuditLogEntry[];
  pagination: ApiPagination;
}

export const auditLogService = {
  /**
   * List audit logs for a tenant with optional filtering and cursor-based pagination
   */
  listAuditLogs: async (tenantId: string, query?: AuditLogListQuery): Promise<ListAuditLogsResponse> => {
    const response = await apiClient.get<ApiCollectionResponse<AuditLogEntry>>(
      `/tenants/${tenantId}/audit-logs`,
      { params: query },
    );
    return {
      items: response.data.data,
      pagination: response.data.pagination,
    };
  },

  /**
   * List audit logs for a specific entity
   */
  listEntityAuditLogs: async (
    tenantId: string,
    entityType: string,
    entityId: string,
    query?: AuditLogListQuery,
  ): Promise<ListAuditLogsResponse> => {
    const response = await apiClient.get<ApiCollectionResponse<AuditLogEntry>>(
      `/tenants/${tenantId}/audit-logs/entities/${entityType}/${entityId}`,
      { params: query },
    );
    return {
      items: response.data.data,
      pagination: response.data.pagination,
    };
  },
};

export default auditLogService;
